import { createFileRoute, notFound } from "@tanstack/react-router";
import { IP_QA, IP_QA_BY_SLUG, IP_REVIEWED_ISO, IP_REVIEWED_TH } from "@/data/ip/questions";
import { ClusterQaDetail, clusterQaDetailHead, type ClusterQaMeta } from "@/lib/qa/cluster-pages";

const M: ClusterQaMeta = { base: "/ip", label: "ทรัพย์สินทางปัญญา", reviewedIso: IP_REVIEWED_ISO, reviewedTh: IP_REVIEWED_TH };

export const Route = createFileRoute("/ip/q/$slug")({
  loader: ({ params }) => { if (!IP_QA_BY_SLUG[params.slug]) throw notFound(); return { slug: params.slug }; },
  head: ({ loaderData }) => clusterQaDetailHead(M, loaderData ? IP_QA_BY_SLUG[loaderData.slug] : undefined),
  component: Page,
});

function Page() {
  const { slug } = Route.useLoaderData();
  const qa = IP_QA_BY_SLUG[slug];
  if (!qa) throw notFound();
  return <ClusterQaDetail m={M} qa={qa} all={IP_QA} />;
}
